const DAY_IN_HOURS = 24;

export const HOUR_IN_MINUTES = 60;
export const DAY_IN_MINUTES = DAY_IN_HOURS * HOUR_IN_MINUTES;

export const MINUTE_IN_SECONDS = 60;
export const HOUR_IN_SECONDS = MINUTE_IN_SECONDS * HOUR_IN_MINUTES;
export const DAY_IN_SECONDS = HOUR_IN_SECONDS * DAY_IN_HOURS;

const SECONDS_IN_MILLS = 1000;
const MINUTE_IN_MILLIS = MINUTE_IN_SECONDS * SECONDS_IN_MILLS;
const HOUR_IN_MILLIS = MINUTE_IN_MILLIS * HOUR_IN_MINUTES;
export const DAY_IN_MILLIS = HOUR_IN_MILLIS * DAY_IN_HOURS;